import { MapPin, Bike } from "lucide-react";

export const OrderSection = () => {
  return (
    <section
      id="siparis"
      data-testid="order-section"
      className="bg-[#E63946] py-16 md:py-24"
    >
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <p className="font-script text-2xl text-white md:text-3xl">Acıktın mı?</p>
        <h2 className="mt-2 max-w-2xl text-4xl font-black uppercase tracking-tighter text-white sm:text-5xl lg:text-6xl">
          Siparişin bir tık uzağında.
        </h2>
        <div className="mt-6 flex flex-wrap gap-x-8 gap-y-3 text-sm font-bold uppercase tracking-wide text-white">
          <a
            href="#subeler"
            data-testid="order-gelal-link"
            className="flex items-center gap-2 transition-opacity hover:opacity-80"
          >
            <MapPin size={18} strokeWidth={2.5} /> Şubede gel-al
          </a>
          <span className="flex items-center gap-2" data-testid="order-delivery-info">
            <Bike size={18} strokeWidth={2.5} /> Paket servis
          </span>
        </div>
        <div className="mt-10 flex flex-wrap items-center gap-4" data-testid="order-platforms">
        </div>
      </div>
    </section>
  );
};
